import React, { useState, useEffect, useRef, Fragment, useCallback } from "react";
import { useSearchParams, } from "react-router-dom";
import Config from "../../Config.json";
import classNames from 'classnames';
import gsap from "gsap";
import {SortableTree} from '../sortableMenu/SortableTree.tsx'
import Icons from '../module.icons';
import { apiCall } from "../narrativeUtils/fetch";
// import { Rnd } from "react-rnd";
import {fileNameType, fileNameTypeString, round30} from "../../utils/helpers";

import {
    useNavigate
  } from "react-router-dom";
import { el } from "date-fns/locale";
import { use } from "react";


function LeftNav(props) {

    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const contextMenuPageRef = useRef();
    const contextMenuLayerRef = useRef();
    const layerClickCooldownRef = useRef(false);
    const [rows, setRows] = useState([]);
    const [sortableMenuItems, setSortableMenuItems] = useState(null)
    const [sortableLayerItems, setSortableLayerItems] = useState(null)
    const [showContextMenu, setShowContextMenu] = useState(false);

    useEffect(() => {
           let showLayers = searchParams.get("layers");
     console.log("showLayers", showLayers, props.showPages)
      if (showLayers === "true") {
        onShowPages(false);
      } else {
        onShowPages(true);
      }
    }, [])
    
    useEffect(() => {
      
      if (props.narrativeHeadings) {

        let newList = [];
        props.narrativeHeadings.forEach((obj, i) => {
          let listObj = {
             id: obj.id.toString(),
             text: "<span>" + obj.heading + "</span>",
             visible: obj.active,
             locked: false,
            'children': []
          }
          if (obj.subs && obj.subs.length > 0) {

            obj.subs.forEach(obj2 => { 
              listObj['children'].push({
                id: obj2.id.toString(),
                text: "<span>" + obj2.heading + "</span>",
                visible: obj2.active,
                locked: false,
                children: []
              })
            })
          }
          newList.push(listObj);
          setSortableMenuItems(newList)
        })
        
      }
    }, [props.narrativeHeadings])

    useEffect(() => {
      console.log("props.activeSettingId, props.narrativeHeadings", props.activeSettingId, props.narrativeHeadings )
    }, [props.activeSettingId, props.narrativeHeadings])

    useEffect(() => {
      if (sortableMenuItems) {
        // console.log('sortableMenuItems', sortableMenuItems)
      }
  }, [sortableMenuItems])

  useEffect(() => {
    if (sortableLayerItems) {
      // console.log('sortableLayerItems', sortableLayerItems)
    }
}, [sortableLayerItems])

const setLayers = useCallback(() => {
  console.log('%c setting layers', "color:red", props.componentDimensions)
  setSortableLayerItems(null)
  let newList = [];
      // .sort((a, b) => b.component_ordering - a.component_ordering)
      props.componentDimensions.filter(a => !a.background && a.parent === null).sort((a,b) => b.component_ordering - a.component_ordering).forEach((obj, i) => {
        let heading;
      

          if (obj.file_format === "statePNGButton") {

            if (obj.layer_name){
             heading = fileNameTypeString(obj.name, obj.layer_name)
            } else {
   
             heading = fileNameTypeString(obj.name, "Tab " + (props.activeSectionObj.states.findIndex(o => o.id === obj.component_id) + 1), 'tab')
   
            } 
            
         } else {
   
           if (props.activeStateId && obj.componentdimensionstateimages.find(cdsi => parseInt(cdsi.state_id) === props.activeStateId)) {
              heading = fileNameTypeString(obj.componentdimensionstateimages.find(cdsi => parseInt(cdsi.state_id) === props.activeStateId).name, null)
           } else {
              if (obj.file_format === "svg" && obj.svg_json && obj.svg_json.objects && obj.svg_json.objects.length > 0) {
                let svgObj = obj.svg_json.objects[0].type.toLowerCase();
                if (obj.svg_json.subtype) {
                   svgObj = obj.svg_json.subtype.toLowerCase();
                }
                heading = fileNameTypeString(obj.name, obj.layer_name, svgObj)
              } else {
                let format = obj.file_format;
  
                heading = fileNameTypeString(obj.name, obj.layer_name, format)
              }
              
            
           }
          
        }

        // Check if this layer has missing media
        const hasMissingMedia = props.missingMediaIds && props.missingMediaIds.includes(obj.id);

        let listObj = {
           id: obj.id.toString(),
           value: obj.layer_name,
           text:  '<div class="mediaFile"><div class="iconField"><span class="layerIconContainer">' + heading + '</span></div></div>',
           visible: obj.active,
           locked: obj.change_lock,
           missingMedia: hasMissingMedia,
           children: []
        }

        // console.log('layer subs', obj.subs)
        if (props.activeDisplay && obj.subs && obj.subs.length > 0) {

            obj.subs.filter(a => a.display === props.activeDisplay.id).forEach(obj2i => {

              let obj2 = props.componentDimensions.find(a => a.id === obj2i.id);

              let heading2;
               if (obj2.file_format === "svg" && obj2.svg_json && obj2.svg_json.objects && obj2.svg_json.objects.length > 0) {
                let svgObj = obj2.svg_json.objects[0].type.toLowerCase();
                if (obj2.svg_json && obj2.svg_json.subtype) {
                   svgObj = obj2.svg_json.subtype.toLowerCase();
                }
                heading2 = fileNameTypeString(obj2.name, obj2.layer_name, svgObj)
              } else {
                heading2 = fileNameTypeString(obj2.name, obj2.layer_name, obj2.file_format)
              }

              // Check if this child layer has missing media
              const childHasMissingMedia = props.missingMediaIds && props.missingMediaIds.includes(obj2.id);

              let child = {
                id: obj2.id.toString(),
                value: obj2.layer_name ? obj2.layer_name : obj2.name,
                text:  '<div class="mediaFile"><div class="iconField"><span class="layerIconContainer">' + heading2 + '</span></div></div>',
                visible: obj2.active,
                locked: obj2.change_lock,
                missingMedia: childHasMissingMedia,
                children: []
              }
              listObj['children'].push(child)

              console.log('layer child', obj2, child, obj2.name, obj2.active)
            })
          }
        // console.log('layer item', obj)
        newList.push(listObj);
        // console.log('newList', newList)
        setSortableLayerItems(newList)
      })
      }, [props.componentDimensions, props.activeSectionObj, props.activeStateId, props.activeDisplay, props.missingMediaIds]);

  useEffect(() => {
    // props.componentDimensions && (console.log(props.componentDimensions))
    if (props.componentDimensions) {
      props.componentDimensions && (console.log('props.componentDimensions', (props.componentDimensions)))
      setLayers();
    } else {
      setSortableLayerItems(null)
    } 
  }, [props.componentDimensions, setLayers])

  useEffect(() => {

    if (!props.showPages) {
      setLayers();
      
    } else {
      setSortableLayerItems(null)
      console.log('clearing layer items')
     
    }
  }, [props.showPages, setLayers])

  useEffect(() => {
    // console.log('%c sortableLayerItems', "color: blue", sortableLayerItems)
  }, [sortableLayerItems])

  useEffect(() => {
    if (showContextMenu !== false){
      let ele = contextMenuLayerRef.current;
      if (props.showPages) {
          ele = contextMenuPageRef.current;
        }

      console.log('onContextMenu',showContextMenu,ele)
      
        
        gsap.to(ele, {zIndex: 5, x: showContextMenu[1] - 30, y: showContextMenu[2] - 30, duration: 0});
        gsap.to(ele, {opacity: 1, duration: 0.3});

        let listener = window.addEventListener('click', function(){
          setShowContextMenu(false);
          gsap.to(ele, {opacity: 0, zIndex: -1, duration: 0});
        })
        window.removeEventListener('click', listener); 
  
    }
  }, [showContextMenu, props.showPages])


    function handleOnActive(objID) {
        // console.log("handleOnActive", objID);
        props.setActiveSettingId(objID)
        var newComponents = [ ...props.componentDimensions ];
        var newIndex = newComponents.findIndex(item => item.id === objID);
        var newObj = newComponents[newIndex];
        var obj = newObj['active'];
        if (obj === true) {
          newObj['active'] = false;
        } else {
          newObj['active'] = true;
        }
        newObj['subs'].forEach((sub, subIndex) => {
            var newIndex = newComponents.findIndex(item => item.id === sub.id);
            if (newIndex > -1) {
                var newSub = newComponents[newIndex];
                newSub['active'] = newObj['active'];
            }
        });
        props.setComponentDimensions(newComponents);
        console.log('handleOnActive', objID, newObj['active'], newObj, newComponents)
        props.setUnSavedChanges(true);
        
        // var newComponents = [...props.componentDimensions];
        // var newIndex = newComponents.findIndex(item => item.id === objID);
        // var newObj = newComponents[newIndex];
        // var obj = newObj['active'];
        // if (obj === true) {
        //   active = false;
  
        // } else {
        //   active = true;
        // }

        // let dataJSON = {
        //   'active': active
        // }
        // const api_url = Config.baseURLcms + 'componentdimension-visibility/' + objID + '/';
        // function responseTask() {
        //   // props.fetchJSON()
        //   // setShowLoader(false);
        // }
        // apiCall('POST', api_url, dataJSON, responseTask, null, props.setFormError, props.setShowLoader)
    }

    function handleOnLock(objID) {
      console.log("handleOnLock", objID);
      
      props.setActiveSettingId(parseInt(objID))
      var newComponents = [...props.componentDimensions];
      var newIndex = newComponents.findIndex(item => item.id === parseInt(objID));
      var newObj = newComponents[newIndex];
      var obj = newObj['change_lock'];
      if (obj === true) {
        newObj['change_lock'] = false;

      } else {
        newObj['change_lock'] = true;
      }
      props.setComponentDimensions(newComponents);

      console.log(newObj['change_lock'], parseInt(objID))
      props.setUnSavedChanges(true);
  }
  

    function handleBackBtn(step){
        if (step === 'step1') {
          props.setShowError(true);
        } 
        if (step === 'cancel') {
            props.setShowError(false);
            props.setShowDeleteSection(false)
        } 
       
        if (step === 'force') {
          if (!props.showPages) {
            console.log('handleBackBtn: force')
            props.setShowPages(true);
            props.setActiveSettingId(null);
            
            props.setShowError(false);
          } else {
            navigate('/narratives/' + props.narrative.id)
            props.setShowError(false);
            
          }
        } 
      }


    // function handleLayerReorderSave(obj) {
 
    //     let api_url = Config.baseURLcms + 'layers-reorder/';
    //     let dataJSON = {'layers': obj};
    //     function responseTask() {
    //       console.log('handleLayerReorderSave: response')
    //     }
    //     apiCall('POST', api_url, dataJSON, responseTask)

    // }

    
      function onShowPages(showPages) {
        props.setShowPages(showPages);

        // Clone current params
        const newParams = new URLSearchParams(searchParams);
        // Overwrite (or add) the `layers` key
        newParams.set("layers", showPages ? "false" : "true");
        // Push the merged params back to the URL
        setSearchParams(newParams);
      }

      function onMenuSort(items) {
        
        console.log('sort pages received', items);
        const api_url = Config.baseURLcms + 'narrativeheading-reorder/';
        let formData = {}
        formData['objs'] = items
        console.log('sending pages reorder', formData['objs'])
        function responseTask() {
          // if (i === a.children.length - 1) {
          //   props.fetchJSON(null, false)
          //   console.log('child sort finished')
          // }
          props.fetchJSON(null, false, null)
        }
        apiCall("POST", api_url, formData, responseTask)
      }

      function onItemClick(id, parentId, e) {
        // console.log("onItemClick rec'd", id, parentId, e)
     
        let obj;
        setSortableLayerItems(null);
        if (parentId) {
          let h = props.narrativeHeadings.find(a => a.id === parseInt(parentId))
          obj = h.subs.find(b => b.id === parseInt(id))  
          props.handlePageClick(obj, e)
        } else {
          obj = props.narrativeHeadings.find(b => b.id === parseInt(id))  
          props.handlePageClick(obj, e)
        }

        // console.log('onItemClick obj', obj)
      }

      function onLayerClick(id, parentId, e){
        // Prevent rapid double-clicks: ignore if still in cooldown
        
        // if (layerClickCooldownRef.current) {
        //   return;
        // }
        // // Engage 1s cooldown
        // layerClickCooldownRef.current = true;
        // setTimeout(() => {
        //   layerClickCooldownRef.current = false;
        // }, 750);

        console.log('onLayerClick', id)
        props.showSettings(Number(id), false, null)
      }

      function onLayerSort(items){
        props.setZoomNumber(1);
        console.log('sort layer received', items);
        const api_url = Config.baseURLcms + 'layers-reorder/';
        let formData = {}
        formData['layers'] = items.reverse();
        console.log('sending layers reorder', formData['layers'])
        function responseTask() {
          let sectionUrl = Config.baseURLcms + "narrative-section/" + props.activeSectionObj.id;
          apiCall("GET", sectionUrl, null, function(sectionResponse) {
            props.setActiveSectionObj(sectionResponse.data);
            props.setShowLoader(false);
          }, null, props.setFormError, props.setShowLoader);
        }
        apiCall("POST", api_url, formData, responseTask)
        
      }

      function onContextMenu(e, objId){
        setShowContextMenu([objId, e.pageX, e.pageY]);
        e.preventDefault();
      }

      function onDuplicatePage(objId) {
        console.log('onDuplicatePage', objId)
         props.setZoomNumber(1);
        const api_url = Config.baseURLcms + 'section-duplicate/';
        let formData = {}
        formData['obj_id'] = objId
        function responseTask() {
          // props.fetchJSON(null, false, null)
          // Fix this:
          window.location.reload();
        }
        apiCall("POST", api_url, formData, responseTask)
      }

       function onDuplicateLayer(objId) {
        console.log('onDuplicateLayer', objId)
         props.setZoomNumber(1);
        const api_url = Config.baseURLcms + 'menu-componentdimension-duplicate/';
        let formData = {}
        formData['obj_id'] = objId
        function responseTask() {
          // props.fetchJSON(null, false, null)
          // Fix this:

          window.location.reload();
        }
        apiCall("POST", api_url, formData, responseTask)
      }

      function onMoveLayer(objId){
        props.setShowMoveModal(objId)

      }

    function onTemplateClose(){
      let back = searchParams.get('back');
      let backArray = back && back.split(',');
      if (backArray && backArray.length > 0) {
        if (back === 'home') {
          window.location.href = '/';
        } else {    
        window.location.href = '/narratives/' + backArray[0] + '/pages?page=' + backArray[1]; 
        console.log('onTemplateClose', back, backArray)
      
      }
    } 

      
    }


    

    function onGroupLayer(objId){
      // let obj = props.componentDimensions.find(a => a.id === parseInt(showContextMenu[0]));
      // if (obj.parent) {

      // } else {
        
      // }

      const api_url = Config.baseURLcms + 'componentdimension-group/';
      let formData = {}
      formData['obj_ids'] = [objId]
      function responseTask() {
        // props.fetchJSON(null, false, null)
         // Fix this:

          window.location.reload();
      }
      apiCall("POST", api_url, formData, responseTask)

      console.log('group components', formData)

    }

    const [showDeleteLayer, setShowDeleteLayer] = useState(false);

    function onDeleteLayer(objId) {
      props.setShowLoader(true);
      props.setZoomNumber(1);
      props.showSettings(objId, false, null);
      props.setActiveSettingId(null);
      const api_url = Config.baseURLcms + 'section-componentdimension-delete/';
      var dataJSON = { 'displaycomponent_id': objId };
      function responseTask() {
        let sectionUrl = Config.baseURLcms + "narrative-section/" + props.sectionId;
        apiCall("GET", sectionUrl, null, function(sectionResponse) {
          props.setActiveSectionObj(sectionResponse.data);
          props.setShowLoader(false);
        }, null, props.setFormError, props.setShowLoader);
      }
      apiCall('POST', api_url, dataJSON, responseTask);
      setShowDeleteLayer(false);
    }

    const btn1 = <span className="visibility"><Icons.Visible className="icon visibleOn" /><Icons.VisibleOff className="icon visibleOff" /></span>

    const btn2 = <span className="lock"><Icons.Lock className="icon" /></span>
     
    return (
        <div className="leftNav">
        {/* Left Nav Starts */}

        {showDeleteLayer && <div className="modalContainer"><div className="modal"><span className="textContainer"><h3>Caution</h3><p>Are you sure you want to delete this layer?<br />This action cannot be undone.</p></span> <div className="fullRow errorRow"><span onClick={() => setShowDeleteLayer(false)}>Cancel</span> <span onClick={() => onDeleteLayer(showDeleteLayer)}>Delete</span></div></div></div>}

        {(showContextMenu !== false && props.showPages) && <div className="contextMenu" ref={contextMenuPageRef}>
          <span className="contextBtn" onClick={() => onDuplicatePage(showContextMenu[0])}>Duplicate</span>
          <span className="break" />
          <span className="contextBtn" style={{color: 'red'}} onClick={() => { props.setShowDeleteSection(true); setShowContextMenu(false); }}>Delete</span>
        </div>}

        {(showContextMenu !== false && !props.showPages) && <div className="contextMenu" ref={contextMenuLayerRef}>
          
          {props.componentDimensions.find(a => a.id === parseInt(showContextMenu[0])).file_format !== 'grp' && <Fragment>
          <span className="contextBtn" onClick={() => onDuplicateLayer(showContextMenu[0])}>Duplicate</span>
          <span className="break" />
          <span className="contextBtn" onClick={() => onMoveLayer(showContextMenu[0])}>Move</span>
          <span className="break" />
          </Fragment>}
          
          <span className="contextBtn" onClick={() => onGroupLayer(showContextMenu[0])}>
           {props.componentDimensions.find(a => a.id === parseInt(showContextMenu[0])).file_format === 'grp' ? "Ungroup" : (props.componentDimensions.find(a => a.id === parseInt(showContextMenu[0])).parent ? "Ungroup":"Group")}
         </span>
          {props.componentDimensions.find(a => a.id === parseInt(showContextMenu[0])).file_format !== 'grp' && !props.componentDimensions.find(a => a.id === parseInt(showContextMenu[0])).background && <Fragment>
          <span className="break" />
          <span className="contextBtn" style={{color: 'red'}} onClick={() => { setShowDeleteLayer(showContextMenu[0]); setShowContextMenu(false); }}>Delete</span>
          </Fragment>}
        </div>}



        {(props.narrative.template_id !== props.narrative.id) && <div className="leftArrow iconField" onClick={() => handleBackBtn((props.unSavedChanges)?('step1'):('force'))}>
          <Icons.ArrowBack className="icon" /> 
          
          <div className="pages">Space Overview</div>
        </div> }

        {(props.narrative && props.narrative.template_id && (props.narrative.template_id === props.narrative.id)) && <div style={{zIndex: 6, position: "relative", background: "var(--light-blue)", width: "calc(100% - 40px)", padding: "0 20px"}}>
           <div className="flex spaceBetween alignCenter" style={{height: "50px"}}>
              <h3 className="flex gap10"><Icons.AddTemplate /> Templates</h3> 

              <span className="flex gap20">
             
                <Icons.Close className="icon ui" onClick={() => onTemplateClose()} />
              </span>
            
            </div>
        </div>}

        <div className="sectionRows">
          <div className="fieldRow sectionHeading">

          <div className="layerToggle">
            <span onClick={() => onShowPages(true)} className={`layerToggleBtn ui${props.showPages?" on":""}`}>Pages</span>
            <span onClick={() => onShowPages(false)} className={`layerToggleBtn ui${!props.showPages?" on":""}`}>
              Layers
              {props.missingMediaIds && props.missingMediaIds.length > 0 && (
                <Icons.Caution className="icon cautionIcon" title="Some layers have missing media" />
              )}
            </span>
          </div>

          {!props.showPages && sortableLayerItems &&
            <div 
              className={"sortableBox"}
            >
        
              <SortableTree  
                collapsible
                defaultItems={sortableLayerItems}
                indicator
                category={'layers'}
                activationConstraint={{
                  delay: 200,
                  tolerance: 15,
                }} 
                activePageId={props.activeSettingId}
                // Functions
                // setEditPageForm={props.setEditPageForm} //this is for delete only
                onMenuSort={onLayerSort}
                onItemClick={onLayerClick}
                btn1={btn1}
                btn2={btn2}
                onBtn1Click={handleOnActive}
                onBtn2Click={handleOnLock}
                onItemContextMenu={onContextMenu}
                isDragActive={true}
                allowNesting={true}
              />
            </div>}
       

          </div>


        </div>
      {props.showPages && sortableMenuItems && 
        <div 
          className={"sortableBox"}
        >        
          <SortableTree 
            collapsible 
            indicator
            category={'pages'}
            defaultItems={sortableMenuItems}
            activationConstraint={{
              delay: 200,
              tolerance: 15,
            }} 
            activePageId={props.activeSectionObj && props.activeSectionObj.nav && props.activeSectionObj.nav.id}
            // Functions
            // setEditPageForm={props.setEditPageForm} //this is for delete only
            onMenuSort={onMenuSort}
            onItemClick={onItemClick}
            onBtn1Click={null}
            onBtn2Click={null}
            onItemContextMenu={onContextMenu}
            isDragActive={true}
            allowNesting={true}
          />
        </div>}
        
    
      {/* Left Nav Ends */}
      </div>
    )
}

export default LeftNav;

